module.exports = {
  en: {
    title: 'Logs',
    subtitle: 'Error logs of triggered webhook event.',
    modalTitle: 'Log details',
    traceId: 'TraceId',
    context: 'Context',
    request: 'Request',
    url: 'URL',
    method: 'Method',
    source: 'Source',
    ssl: 'SSL',
    headers: 'Headers',
    parameters: 'Parameters',
    response: 'Response',
    statusCode: 'Status code',
    statusName: 'Status name',
    errorHint: 'This is the error that we have caught trying to send the event',
    payload: 'Payload',
    payloadHint: 'This is the payload that was attempted to be sent',
    serverResponse: 'Server response',
    template: 'Template (ETL)',
    templateHint: 'Original template was defined in the webhook',
    emptyParameters: 'No parameters provided',
  },
  es: {
    title: 'Registros',
    subtitle: 'Listado de errores de eventos disparados.',
    modalTitle: 'Detalles del registro',
    traceId: 'TraceId',
    context: 'Contexto',
    request: 'Solicitud',
    url: 'URL',
    method: 'Método',
    source: 'Fuente',
    ssl: 'SSL',
    headers: 'Encabezados',
    parameters: 'Parámetros',
    response: 'Respuesta',
    statusCode: 'Código de estado',
    statusName: 'Nombre del estado',
    errorHint: 'Este es el error que hemos capturado al intentar enviar el evento',
    payload: 'Carga útil',
    payloadHint: 'Esta es la carga útil que se intentó enviar',
    serverResponse: 'Respuesta del servidor',
    template: 'Plantilla (ETL)',
    templateHint: 'La plantilla original fue definida en el webhook',
    emptyParameters: 'No se proporcionaron parámetros',
  },
  fr: {
    title: 'Enregistrements',
    subtitle: 'Liste des erreurs d\'événements déclenchés.',
    modalTitle: 'Détails de l\'enregistrement',
    traceId: 'TraceId',
    context: 'Contexte',
    request: 'Demande',
    url: 'URL',
    method: 'Méthode',
    source: 'Source',
    ssl: 'SSL',
    headers: 'En-têtes',
    parameters: 'Paramètres',
    response: 'Réponse',
    statusCode: 'Code d\'état',
    statusName: 'Nom de l\'état',
    errorHint: 'C\'est l\'erreur que nous avons capturée lors de l\'envoi de l\'événement',
    payload: 'Charge utile',
    payloadHint: 'C\'est la charge utile qui a été tentée d\'envoyer',
    serverResponse: 'Réponse du serveur',
    template: 'Modèle (ETL)',
    templateHint: 'Le modèle original a été défini dans le webhook',
    emptyParameters: 'Aucun paramètre fourni',
}

};
